import { useContext } from 'react'
import { AppContext } from 'contexts/AppProvider'
import { serviceEndpoints } from 'variables/services'
import useCurrentUser from 'hooks/useCurrentUser'
import { setIsRefreshMembershipSession } from 'helpers/sessionStorage'
import {
  useCurrentUserCampaignDataPackQuery,
  type CurrentUserCampaignDataPackQuery,
} from 'graphQL/hatostore/generate/operations'

const { liffAPILimit } = serviceEndpoints

interface useGetUserCampaignDataPackProps {
  handleIsNotLineFriend: VoidFunction
  onCompleted?: (data: CurrentUserCampaignDataPackQuery) => void
  apiEndpoint?: string
}

function useGetUserCampaignDataPack({
  handleIsNotLineFriend,
  onCompleted = (data) => {},
  apiEndpoint = liffAPILimit,
}: useGetUserCampaignDataPackProps) {
  const { setCurrentMembership, setIsInitialedCurrentMembership } = useContext(AppContext)

  const resUserCampaignDataPack = useCurrentUserCampaignDataPackQuery({
    context: {
      uri: apiEndpoint,
    },
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      onCompleted(data)

      if (data.currentMembership) {
        setCurrentMembership(data.currentMembership)
      }

      setIsInitialedCurrentMembership(true)
      setTimeout(() => setIsRefreshMembershipSession(true))
    },
  })

  const _currentUser =
    resUserCampaignDataPack.data && resUserCampaignDataPack.data.currentUser
      ? resUserCampaignDataPack.data.currentUser
      : ''

  useCurrentUser({ currentUserData: _currentUser, handleIsNotLineFriend })

  return [resUserCampaignDataPack]
}

export default useGetUserCampaignDataPack
